import React, { useState, useEffect } from 'react';
import { Builder } from '@builder.io/react';
import { useSelector } from 'react-redux';
import { selectSelectedCurrency } from '../../../../../store/user';
import { selectProducts } from '../../../../../store/products';
import ConvertUSD from '../../../../../utils/convertUSD';
import ShowCurrencies from '../../../../../utils/showCurrencies';
import MatwLogo from '../../../../../images/landings/love-ones/MATW-logo-2-1.png';

const MasjidWidget = ({
  image,
  title = "We're building a Masjid",
  goal = 29400,
  raised = 20500,
  creatorId = "GD-MP015"
}) => {
  const selectedCurrency = useSelector(selectSelectedCurrency);
  const products = useSelector(state => selectProducts(state));
  const [productData, setProductData] = useState({
    goal: goal,
    raised: raised,
    creator: creatorId
  });
  const [isLoaded, setIsLoaded] = useState(false);

  const handlePercentage = (raised, goal) => {
    return `${((Number(raised) / Number(goal)) * 100).toFixed(2)}%`;
  };

  useEffect(() => {
    if (products && products.length > 0) {
      let foundProduct = null;
      
      products.forEach((item) => {
        if (item.products) {
          item.products.forEach((inner_item) => {
            inner_item.products.forEach((inner_item_product) => {
              if (inner_item_product.creator === creatorId) {
                foundProduct = {
                  goal: inner_item_product.goal || goal,
                  raised: inner_item_product.raised || raised,
                  creator: inner_item_product.creator
                };
              }
            });
          });
        }
      });
      
      if (foundProduct) {
        setProductData(foundProduct);
      }
      setIsLoaded(true);
    }
  }, [products, creatorId, goal, raised]);

  const convertedRaised = ConvertUSD(selectedCurrency, productData.raised, false);
  const convertedGoal = ConvertUSD(selectedCurrency, productData.goal, false);
  const progressPercentage = handlePercentage(convertedRaised, convertedGoal);

  return (
    <div className="w-full max-w-xs mx-auto rounded-2xl shadow-lg bg-white overflow-hidden">
              {image && (
          <div className="relative overflow-hidden rounded-t-2xl h-64">
            <img className="w-full h-full object-cover transform scale-110" src={image} alt="Masjid" />
          </div>
        )}
      
      <div className="p-4 md:p-6">
        <div className="flex items-center">
          <img src={MatwLogo} alt="matw" className="w-6 md:w-8 mr-2" />
          <p className="text-sm">MATW Project</p>
        </div>

        <h3 className="text-gray-800 text-xl font-semibold mb-4 mt-2 leading-tight">
          {title}
        </h3>
        <div className="mb-6">
          <div className="flex w-full h-2 bg-gray-200 rounded-full mb-4">
            <div
              className="bg-green-600 rounded-full"
              style={{
                width: progressPercentage,
              }}
            ></div>
          </div>
          
          <div className="flex justify-between items-center">
            <div className="flex flex-col">
              <h3 className="text-2xl font-bold text-gray-800">
                {ShowCurrencies(selectedCurrency, convertedRaised)}
              </h3>
              <p className="text-sm text-gray-600">
                funded of {ShowCurrencies(selectedCurrency, convertedGoal)}
              </p>
            </div>
            <div className="ml-4">
              <div className="bg-green-600 text-white px-6 py-2 rounded-full text-lg font-semibold">
                Success!
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

Builder.registerComponent(MasjidWidget, {
  name: 'MasjidWidget',
  inputs: [
    {
      name: 'image',
      type: 'file',
      allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg', 'webp'],
      friendlyName: 'Masjid Image',
      helperText: 'Upload the main image for the masjid widget'
    },
    {
      name: 'title',
      type: 'string',
      defaultValue: "We're building a Masjid",
      friendlyName: 'Title',
      helperText: 'The main title displayed on the masjid widget'
    },
    {
      name: 'goal',
      type: 'number',
      defaultValue: 29400,
      friendlyName: 'Funding Goal',
      helperText: 'The funding goal amount in USD'
    },
    {
      name: 'raised',
      type: 'number',
      defaultValue: 20500,
      friendlyName: 'Amount Raised',
      helperText: 'The current amount raised in USD'
    },
    {
      name: 'creatorId',
      type: 'string',
      defaultValue: 'GD-MP015',
      friendlyName: 'Creator ID',
      helperText: 'The creator ID to fetch real product data from the store'
    }
  ]
});

export default MasjidWidget;